<h2 class="mt-3 mb-4">Update Reset Question</h2>
<div class="notice notice-error" *ngIf="error">
  <div class="notice-body">Failed to update reset question<br>{{ error?.description }}</div>
</div>
<div class="notice" *ngIf="success">
  <div class="notice-body">Successfully changed reset question and answer</div>
</div>
<div class="notice" *ngIf="f.question.pristine && f.answer.dirty">
  <div class="notice-body">The reset answer only changes when the reset question is changed.</div>
</div>

<form [formGroup]="ResetQuestionForm" class="material-form-grid">
  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Password Reset Question</mat-label>
    <input matInput id="question" formControlName="question" />
  </mat-form-field>

  <app-all-seeing-eye label="Password Reset Answer" formControlName="answer" class="mgr-10"></app-all-seeing-eye>


  <app-all-seeing-eye label="Current Password" formControlName="currentpass" hintText="Required for authorisation"></app-all-seeing-eye>

  <div class="form-actions full-width">
    <button mat-flat-button color="primary" id="reset-question-save-button" type="button" (click)="modifyResetQuestion()"
      [disabled]="saveDisabled()">
      <mat-spinner *ngIf="saving" diameter="20" mode="indeterminate"></mat-spinner>
      {{ saving ? 'Saving' : 'Save' }}
    </button>
  </div>
</form>
